export const colors = {
    baseColor: "#f2f2f2",
    highlightColor: "#e0e0e0",
  };
  